export default {"src":"/_next/static/media/shabLogo.cecc30bf.svg","height":33,"width":82,"blurWidth":0,"blurHeight":0};